import {enableProdMode} from '@angular/core';
import {platformBrowser} from '@angular/platform-browser';
// Конкретный путь, не barrel compob2b-libs: main.ts исполняется ДО bootstrap,
// barrel утащил бы весь Angular-граф раньше времени (та же ловушка, что в ui-locale.ts).
import {setSupportedLocales} from 'compob2b-libs/src/lib/i18n/locale';
import {initAdminUiI18n} from './app/admin-shared/i18n/i18n-init';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

(async () => {
  // Состав контент-локалей — из environment, ДО любого чтения локали
  // (initAdminUiI18n → readUiLocale валидирует против SUPPORTED_LOCALES).
  setSupportedLocales(environment.contentLocales);
  // Переводы должны быть готовы ДО загрузки кода приложения: конфиги форм и
  // шаблонные $localize-константы вычисляются при импорте модулей, поэтому
  // AppModule подгружается динамически после initAdminUiI18n().
  await initAdminUiI18n();
  const {AppModule} = await import('./app/app.module');
  platformBrowser()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
})();
